// extracted by mini-css-extract-plugin
export default {"buttonAdmin":"Admin_buttonAdmin__pAlpV","title":"Admin_title__NMu4r","buttonBackup":"Admin_buttonBackup__1Bqx2"};